import { get, find, isEqual, uniqBy, differenceBy } from "lodash";
import moment from "moment";

import {
  DealRoomAction,
  DealRoomActionEditChanges,
  DealRoomRecipient,
} from "src/types/dealRoom";
import { Asset } from "src/types/assets";

const hasDueDateChanged = (
  newDueDate?: string | null,
  oldDueDate?: string | null,
) => {
  if (!newDueDate && !oldDueDate) {
    return false;
  }

  if (!newDueDate || !oldDueDate) {
    return true;
  }

  return !moment(newDueDate).isSame(moment(oldDueDate));
};

export const getActionChanges = (
  action: DealRoomAction,
  savedActions: DealRoomAction[],
  actionId: string,
) => {
  const changes: DealRoomActionEditChanges = {};
  let stakeholdersToBeNotified: DealRoomRecipient[] = [];

  const newDueDate = get(action, "dueDate", "");
  const newRecipients = get(action, "recipients", []);
  const newAssets = get(action, "assets", []);
  const newActionItem = get(action, "actionItem", "");

  const oldAction = find(savedActions, (action) => action.id === actionId);

  if (!oldAction) {
    return { changes, stakeholdersToBeNotified: newRecipients };
  }

  const oldRecipients = get(
    oldAction,
    "recipients",
    [],
  ) as DealRoomRecipient[];
  const oldAssets = get(oldAction, "assets", []) as Asset[];
  const oldDueDate = get(oldAction, "dueDate", "");
  const oldActionItem = get(oldAction, "actionItem", "");

  if (!isEqual(newActionItem, oldActionItem)) {
    changes.actionItem = newActionItem ?? "";
  }
  if (!isEqual(newRecipients, oldRecipients)) {
    changes.recipients = newRecipients ?? [];

    const newlyAddedRecipients = differenceBy(newRecipients, oldRecipients, 'shareRecipient');
    const removeRecipients = differenceBy(oldRecipients, newRecipients, 'shareRecipient');

    stakeholdersToBeNotified = [...stakeholdersToBeNotified, ...newlyAddedRecipients, ...removeRecipients];
  }
  if (!isEqual(newAssets, oldAssets)) {
    changes.assets = newAssets ?? [];

    stakeholdersToBeNotified = [...stakeholdersToBeNotified, ...oldRecipients];
  }
  if (hasDueDateChanged(newDueDate, oldDueDate)) {
    changes.dueDate = newDueDate ?? "";

    stakeholdersToBeNotified = [...stakeholdersToBeNotified, ...oldRecipients];
  }

  const result = { changes, stakeholdersToBeNotified: uniqBy(stakeholdersToBeNotified, "shareRecipient") };
  return result;
};
